var _circle, _rect, _rect2, _path, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptystate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 146,
    viewBox: "0 0 114 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 56.7081,
    cy: 56.7081,
    r: 56.7081,
    fill: "#F1F1F1"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 34.4614,
    y: 55.5523,
    width: 55.5184,
    height: 77.7258,
    rx: 5.55184,
    transform: "rotate(2.5 34.4614 55.5523)",
    stroke: "#D9DBEA",
    strokeWidth: 1.58624
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.45584,
    y: 50.903,
    width: 58.6909,
    height: 80.8983,
    rx: 7.13808,
    transform: "rotate(-7.5 1.45584 50.903)",
    fill: "#FAFAFA",
    stroke: "#D9DBEA",
    strokeWidth: 1.58624
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.17413 57.8765C2.71674 54.4023 5.16238 51.215 8.63663 50.7576L52.6714 44.9603C56.1456 44.503 59.3329 46.9486 59.7903 50.4228L61.3431 62.2179L4.72698 69.6715L3.17413 57.8765Z",
    fill: "#EEEEEE"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 71.2747,
    y: 46.511,
    width: 2.37936,
    height: 7.9312,
    rx: 1.18968,
    transform: "rotate(82.5 71.2747 46.511)",
    fill: "#D9DBEA"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 49.5457,
    y: 33.3723,
    width: 2.37936,
    height: 7.9312,
    rx: 1.18968,
    transform: "rotate(-7.5 49.5457 33.3723)",
    fill: "#D9DBEA"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 63.4868,
    y: 35.5367,
    width: 2.37936,
    height: 7.9312,
    rx: 1.18968,
    transform: "rotate(37.5 63.4868 35.5367)",
    fill: "#D9DBEA"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 10.6453,
    y: 72.0923,
    width: 46.001,
    height: 3.17248,
    rx: 1.58624,
    transform: "rotate(-7.5 10.6453 72.0923)",
    fill: "#D9DBEA"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 12.7157,
    y: 87.819,
    width: 46.001,
    height: 3.17248,
    rx: 1.58624,
    transform: "rotate(-7.5 12.7157 87.819)",
    fill: "#D9DBEA"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 14.7863,
    y: 103.546,
    width: 46.001,
    height: 3.17248,
    rx: 1.58624,
    transform: "rotate(-7.5 14.7863 103.546)",
    fill: "#D9DBEA"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 11.4734,
    y: 78.3829,
    width: 16.6555,
    height: 3.17248,
    rx: 1.58624,
    transform: "rotate(-7.5 11.4734 78.3829)",
    fill: "#EEEEEE"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 13.5439,
    y: 94.1096,
    width: 16.6555,
    height: 3.17248,
    rx: 1.58624,
    transform: "rotate(-7.5 13.5439 94.1096)",
    fill: "#EEEEEE"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 15.6144,
    y: 109.836,
    width: 16.6555,
    height: 3.17248,
    rx: 1.58624,
    transform: "rotate(-7.5 15.6144 109.836)",
    fill: "#EEEEEE"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptystate);
export default __webpack_public_path__ + "static/media/emptystate.a94d51299cce1bd187dda2864fc2f652.svg";
export { ForwardRef as ReactComponent };